// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext} from 'react';
import {Redirect, useHistory} from 'react-router-dom';
import cn from 'classnames';
import {Settings_context} from '../../settings_ctx';
import {use_cp} from '../../ui/cp/use_cp';
import {CP_profile} from '../../ui/cp/cp_profile';
import {CP_premium} from '../../ui/cp/cp_premium';
import {CP_settings} from '../../ui/cp/cp_settings';
import {CP_apps} from '../../ui/cp/cp_apps';
import {CP_menu} from '../../ui/cp/cp_menu';
import {CP_support} from '../../ui/cp/cp_support';
import {Modal} from '../../../../shared/ui/modal';
import {State_signup_check_email}
    from '../../ui/login/state_signup_check_email';
import {Svg_img} from '../../ui/svg_img';

import styles from './cp.module.less';

export const Root = (props: object_of<any>)=>{
    const root_path = props.root_path || '/cp';
    const {theme} = useContext(Settings_context);
    const history = useHistory();
    const {tab, premium, settings, apps, user_email,
        is_mobile, back_btn, user, unverified, on_verify,
    } = use_cp(props.user_country, root_path);
    if (!user)
    {
        return <Redirect to={{pathname: '/', state: {need_login: true,
          next: root_path}}}/>;
    }
    const hp_redirect = ()=>{ history.push('/'); };
    return <div className={cn(theme.root, styles.root)}>
      {is_mobile ? <div className={styles.mobile}>
        {tab=='menu' && <CP_menu class_name={styles.menu}
          active={tab} root_path={root_path}/>}
        {tab=='profile' && <CP_profile back_btn={back_btn}
          is_mobile={is_mobile}/>}
        {tab=='premium' && <CP_premium premium={premium} back_btn={back_btn}
          is_mobile={is_mobile}/>}
        {tab=='settings' && <CP_settings settings={settings}
          back_btn={back_btn}/>}
        {tab=='apps' && <CP_apps apps={apps} back_btn={back_btn}/>}
        {tab=='support' && <CP_support back_btn={back_btn}
          is_mobile={is_mobile}/>}
      </div> : <div className={styles.desktop}>
        <div className={styles.top}>
          <Svg_img w={928} h={152} id={'cp/header_bg.svg'}/>
        </div>
        <div className={styles.main}>
          <CP_menu class_name={styles.menu}
            active={tab} root_path={root_path}/>
          {tab=='profile' && <CP_profile />}
          {tab=='premium' && <CP_premium premium={premium}
            back_btn={null} is_mobile={false} />}
          {tab=='settings' && <CP_settings settings={settings}/>}
          {tab=='apps' && <CP_apps apps={apps}/>}
          {tab=='support' && <CP_support/>}
        </div>
      </div>}
      {unverified && <Modal is_open={unverified} on_close={hp_redirect}
        width={468} cls={styles.unverified_modal} no_logo>
        <State_signup_check_email email={user_email} on_verify={on_verify}
          full_footer/>
      </Modal>}
    </div>;
};
Root.meta = {
    meta: opt=>{
        const {params} = opt;
        let canonical_url = 'https://hola.org/cp';
        if (params?.cp)
            canonical_url = canonical_url+'/'+params.cp;
        return {title: 'Hola | My account', canonical_url};
    },
    no_ssr: true,
    footless: true,
    default_theme: 'hola2023',
};
